import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "user-profile__name" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "user-profile__dropdown-content" }
const _hoisted_4 = { class: "user-profile__role" }

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { names } from '@/constants/routes';
import { roles } from '@/constants/roles';
import { useClickOutside } from '@/libraries/useClickOutside';

import Dropdown from '@/components/Dropdown.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import CleanButton from '@/components/CleanButton.vue';

import { logoutUser } from '@/services/userActions';
import { LoggedUser } from '@/types/user';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfile',
  emits: ["lockLogin"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const $el = ref<HTMLDivElement | null>(null);
const isShow = ref(false);
const { t } = useI18n();

const emit = __emit;

const userData = computed<LoggedUser>(() => store.state.UserData.user);
const firstName = computed<string>(() => {
  if (userData.value.firstname && userData.value.firstname?.length > 16) {
    return `${userData.value.firstname?.slice(0, 16)}...`;
  }
  return userData.value.firstname || '';
});

const secondName = computed<string>(() => (userData.value.surname || '').charAt(0));

const displayedRole = computed<string>(() => {
  const roleData = userData.value.role;
  if (roleData.shortname === roles.student && !userData.value.organization) {
    return t('roles.user');
  }
  return t(`roles.${roleData.shortname}`);
});

const handleToggle = (): void => {
  isShow.value = !isShow.value;
};

const handleClose = (): void => {
  isShow.value = false;
};

const handleLogout = async (): Promise<void> => {
  disableLoginBtn();
  handleClose();
  store.commit('SET_IS_LOGGING_OUT', true);
  await logoutUser();
  await store.dispatch('clearUserData');
};

const isDisabledLogBtn = ref(false);
const showLoader = computed(() => store.getters['Common/showLoader']);

const disableLoginBtn = () => {
  isDisabledLogBtn.value = true;
  emit('lockLogin', true);
};

useClickOutside($el, handleClose);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$el",
    ref: $el,
    class: "user-profile"
  }, [
    _createVNode(Dropdown, {
      show: isShow.value,
      indent: 0,
      right: "",
      class: "user-profile__dropdown"
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["user-profile__trigger nav-link__animated-bg", { active: isShow.value }]),
          onClick: handleToggle
        }, [
          _createElementVNode("h3", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString(firstName.value), 1),
            (secondName.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " " + _toDisplayString(secondName.value) + ". ", 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(UserAvatar, {
            avatarLink: userData.value.small_avatar,
            class: "user-profile__avatar"
          }, null, 8, ["avatarLink"])
        ], 2)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(displayedRole.value), 1),
          _createVNode(_component_router_link, {
            to: { name: _unref(names).profile },
            class: "user-profile__link",
            onClick: handleClose
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("menus.profile")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(CleanButton, {
            class: "user-profile__link",
            disabled: isDisabledLogBtn.value || showLoader.value,
            onClick: handleLogout
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("menus.logout")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 512))
}
}

})